module.exports = __webpack_public_path__ + "static/media/IMG_2214.f9a61b61.JPG";